module.exports = __webpack_public_path__ + "img/dry-hairy-tree-06.1fa0014e.png";